import { ToolUsageAccuracyStatus } from "@repo/app-types/entities/toolUsageAccuracy";
import {
  IconCircleCheck,
  IconCircleMinus,
  IconCircleX,
  IconExclamationCircle,
} from "@tabler/icons-react";
import type { FC } from "react";
import { tv } from "tailwind-variants";

export interface ToolUsageAccuracyStatusIconProps {
  status: ToolUsageAccuracyStatus;
}

const iconComponent: Record<ToolUsageAccuracyStatus, typeof IconCircleCheck> = {
  [ToolUsageAccuracyStatus.UsedCorrect]: IconCircleCheck,
  [ToolUsageAccuracyStatus.UnusedCorrect]: IconCircleMinus,
  [ToolUsageAccuracyStatus.UsedIncorrect]: IconCircleX,
  [ToolUsageAccuracyStatus.UsedFailed]: IconExclamationCircle,
  [ToolUsageAccuracyStatus.UnusedIncorrect]: IconCircleX,
};

const iconStyle = tv({
  base: "size-4 shrink-0",
  variants: {
    status: {
      [ToolUsageAccuracyStatus.UsedCorrect]: "text-success",
      [ToolUsageAccuracyStatus.UnusedCorrect]: "text-gray-400",
      [ToolUsageAccuracyStatus.UsedIncorrect]: "text-destructive",
      [ToolUsageAccuracyStatus.UsedFailed]: "text-amber-600",
      [ToolUsageAccuracyStatus.UnusedIncorrect]: "text-destructive",
    },
  },
});

export const ToolUsageAccuracyStatusIcon: FC<
  ToolUsageAccuracyStatusIconProps
> = (props) => {
  const Icon = iconComponent[props.status];

  return <Icon className={iconStyle({ status: props.status })} />;
};
